module.exports = __webpack_public_path__ + "static/media/91.21cf7712.jpg";